import React from 'react';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const ConditionalLinkFromTile_ViewerVersion1 = ({
  linkTarget, 
  linkHref, 
  doesTileLinkToVideo, 
  children, 
  onLinkToVideoClick 
})=> {
  if (linkHref) {
    return (
      <a 
        href={linkHref}
        target={linkTarget} 
        className="grid-tile-wrapper" 
        onClick={doesTileLinkToVideo ? onLinkToVideoClick : null}
      >
        { children }
      </a>
    );
  }

  return children;
};

// accessible components shouldn't be wrapped in a link, we handle that elsewhere
const ConditionalLinkFromTile_ViewerVersion2 = ({ children })=> {
  return children;
};

const ConditionalLinkFromTile = (props)=> (
  <SiteViewerVersionComponentSelector>
    <ConditionalLinkFromTile_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <ConditionalLinkFromTile_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default ConditionalLinkFromTile;
